// Correct these import paths based on your project structure relative to src/services
import { BODY_TYPE, CommonApiOptions, METHOD_TYPE } from "../constants/api"; // Adjust path as needed
import configs from "../configs/apiConfigs"; // Adjust path as needed
import { commonApi } from "../helpers/api"; // Adjust path as needed
import { attachHeader } from "../utils/apiHandler"; // Adjust path as needed

// Function to fetch current rankings
export const fetchRankings = async (
  clinicUniqueId: string,
  month: number,
  year: number
) => {
  try {
    const request: CommonApiOptions = {
      url:
        configs.API_URL +
        `rankinglist/${clinicUniqueId}/?month=${month}&year=${year}`,
      method: METHOD_TYPE.GET,
      // GET requests typically don't have a request body
      // body: { type: BODY_TYPE.RAW, data: {} },
      apiOptions: {
        headers: attachHeader(true), // Assuming authentication is needed
        withCredentials: true,
      },
    };

    const res = await commonApi(request);

    // Example error handling based on your provided code pattern
    if (res?.status === 400) {
      // toast('error', res.message);
    }
    // Note: Your example checks error.response.status, commonApi might return a different structure on error.
    // You might need to adjust error handling based on what commonApi returns for errors.

    return res; // Return the response from commonApi
  } catch (error: any) {
    console.error("Error fetching rankings:", error);
    // Example error handling based on your provided code pattern
    if (error.response && error.response.status === 401) {
      console.log("error", error.response.data.message);
    } else if (error.response && error.response.statusText) {
      console.log("error", error.response.statusText);
    } else {
      console.log("error", "An unexpected error occurred");
    }
    return error?.response; // Return error response
  } finally {
  }
};

export const fetchRankingsTrends = async (
  clinicUniqueId: string,
  year: number
) => {
  try {
    const request: CommonApiOptions = {
      url: configs.API_URL + `ranking-graph/${clinicUniqueId}/?year=${year}`,
      method: METHOD_TYPE.GET,
      // GET requests typically don't have a request body
      // body: { type: BODY_TYPE.RAW, data: {} },
      apiOptions: {
        headers: attachHeader(true), // Assuming authentication is needed
        withCredentials: true,
      },
    };

    const res = await commonApi(request);

    // Example error handling based on your provided code pattern
    if (res?.status === 400) {
      // toast('error', res.message);
    }
    // Note: Your example checks error.response.status, commonApi might return a different structure on error.
    // You might need to adjust error handling based on what commonApi returns for errors.

    return res; // Return the response from commonApi
  } catch (error: any) {
    console.error("Error fetching rankings:", error);
    // Example error handling based on your provided code pattern
    if (error.response && error.response.status === 401) {
      console.log("error", error.response.data.message);
    } else if (error.response && error.response.statusText) {
      console.log("error", error.response.statusText);
    } else {
      console.log("error", "An unexpected error occurred");
    }
    return error?.response; // Return error response
  } finally {
  }
};

// Function to add a new ranking
export const addRanking = async (rankingData: any, clinicUniqueId: string) => {
  try {
    const request: CommonApiOptions = {
      url: configs.API_URL + `addranking/${clinicUniqueId}/`, // Example URL, adjust as needed
      method: METHOD_TYPE.POST,
      body: {
        type: BODY_TYPE.RAW,
        data: rankingData,
      },
      apiOptions: {
        headers: attachHeader(true), // Assuming authentication is needed
        withCredentials: true,
      },
    };

    const res = await commonApi(request);

    // Example error handling
    if (res?.status === 400) {
      // toast('error', res.message);
    }

    return res; // Return the response
  } catch (error: any) {
    console.error("Error adding ranking:", error);
    // Example error handling
    if (error.response && error.response.status === 401) {
      console.log("error", error.response.data.message);
    } else if (error.response && error.response.statusText) {
      console.log("error", error.response.statusText);
    } else {
      console.log("error", "An unexpected error occurred");
    }
    return error?.response; // Return error response
  } finally {
  }
};

// Function to edit an existing ranking
export const editRanking = async (rankingData: any, clinicUniqueId: string) => {
  try {
    const request: CommonApiOptions = {
      url: configs.API_URL + `updateranking/${clinicUniqueId}/`, // Example URL, adjust as needed
      method: METHOD_TYPE.POST, // Assuming PUT for edit is more RESTful, adjust if your API uses POST
      body: {
        type: BODY_TYPE.RAW,
        data: rankingData,
      },
      apiOptions: {
        headers: attachHeader(true), // Assuming authentication is needed
        withCredentials: true,
      },
    };

    const res = await commonApi(request);

    // Example error handling
    if (res?.status === 400) {
      // toast('error', res.message);
    }

    return res; // Return the response
  } catch (error: any) {
    console.error(`Error editing ranking:`, error);
    // Example error handling
    if (error.response && error.response.status === 401) {
      console.log("error", error.response.data.message);
    } else if (error.response && error.response.statusText) {
      console.log("error", error.response.statusText);
    } else {
      console.log("error", "An unexpected error occurred");
    }
    return error?.response; // Return error response
  } finally {
  }
};

// Function to delete a ranking
export const deleteRanking = async (
  clinicUniqueId: string,
  rankingId: number
) => {
  try {
    const request: CommonApiOptions = {
      url: configs.API_URL + `deleteranking/${clinicUniqueId}/`, // Example URL, adjust as needed
      method: METHOD_TYPE.POST,
      body: {
        type: BODY_TYPE.RAW,
        data: { id: rankingId },
      },
      apiOptions: {
        headers: attachHeader(true), // Assuming authentication is needed
        withCredentials: true,
      },
    };

    const res = await commonApi(request);

    // Example error handling
    if (res?.status === 400) {
      // toast('error', res.message);
    }

    return res; // Return the response
  } catch (error: any) {
    console.error(`Error deleting ranking ${rankingId}:`, error);
    // Example error handling
    if (error.response && error.response.status === 401) {
      console.log("error", error.response.data.message);
    } else if (error.response && error.response.statusText) {
      console.log("error", error.response.statusText);
    } else {
      console.log("error", "An unexpected error occurred");
    }
    return error?.response; // Return error response
  } finally {
  }
};
